<template>
  <div class="home-container">
    <div
      v-if="isExistWallet"
      class="pay-box"
    >
      <PayMwalletSkylight
        :poi="`${poiForWallet}`"
        :token="bizlogintoken"
        :source="$isWXApplet?'65':'27'"
      />
      <div
        class="confirm-box"
        :data-bid="$BID.HOME_WALLET_DEPOSIT"
        :data-cid="cid"
        @click="onClickDeposit"
      >
        <div class="confirm-text">
          去提现
          <img
            class="icon-arrow"
            src="@/assets/img/arrow-right@2x.png"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import PayMwalletSkylight from '@mx/vue-chongdianbao-skylight-sdk';
import { ACCOUNT_ROLE } from '@/constants/common';
import '@/assets/css/page/home.scss';
import tracker from '@/util/tracker';

export default {
  name: 'WalletOnHomepage',
  components: {
    PayMwalletSkylight,
  },
  props: {
    accountRole: {
      type: Number,
      required: true,
    },
    existWallet: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  computed: {
    ...mapState(['bizlogintoken']),
    ...mapGetters(['poiForWallet']),
    isBypassAccount() {
      return this.accountRole === ACCOUNT_ROLE.Bypass;
    },
    isExistWallet() {
      const b = Boolean(this.existWallet);
      if (b) {
        tracker.sendModuleView(this.$BID.HOME_WALLET_MV, null, { cid: this.cid });
      }
      return b;
    },
    cid() {
      return this.$CID.Home;
    },
  },
  methods: {
    onClickDeposit() {
      this.$emit('do-deposit');
    },
  },
};
</script>

<style lang="scss" scoped>
.home-container {
  position: relative;
}
.confirm-box {
  position: absolute;
  top: 0;
  right: 0;

  .confirm-text {
    position: absolute;
    top: 0;
    right: 32px;
    width: 400px;
    padding-top: 45px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    background-color: white;
  }

  .icon-arrow {
    width: 24px;
    height: 24px;
    margin-left: 12px;
  }
}
.red-text {
  color: #F5483B !important;
}

.content {
  padding: 0.3rem 0 1.02rem;
  text-align: center;
  font-size: 0.26rem;
}

.to-create-wallet {
  margin-left: 0.1rem;
  color: #FE8C00;
  font-weight: 800;
  font-size: 0.28rem;
}
</style>

<style lang="scss">
.wallet-confirm-dialog {
  width: 80% !important;

  .van-dialog__message,
  .van-dialog__confirm {
    font-size: 0.28rem;
  }

  .dialog__message {
    line-height: 1.2;
    padding: 0.48rem;
  }
}
</style>
